const ApiResponseFormatEnum = Object.freeze({
    SUMMARY: 10, // id, name
    DETAIL: 20, // All base fields and relationship summary fields
    FULL: 30 // All base fields and relationship details
});

export default ApiResponseFormatEnum;
